import React from "react";
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Radio,
    RadioGroup,
    Typography
} from "@mui/material";

interface CourseCreateStepThreeProps {
    courseData: {
        category_id: string;
        name: string;
        planned_time: string;
        subscribe: boolean;
    };
    setStep: (step: number) => void;
    createCourse: (data: {
        category_id: string;
        name: string;
        planned_time: string;
        subscribe: boolean;
    }) => void;
    handleStepChange: (data: {
        planned_time: string;
    }) => void;
}

const CourseCreateStepThree = ({courseData, setStep, createCourse, handleStepChange }: CourseCreateStepThreeProps) => {
    const initialValues = {
        planned_time: courseData.planned_time || '',
    };

    const validationSchema = Yup.object({
        planned_time: Yup.string().required('Необходимо выбрать один из вариантов'),
    });

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                createCourse({...courseData, ...values});
            }}
        >
            {({ errors, touched, setFieldValue }) => (
                <Form>
                        <div className="course-content">
                            <Typography variant="h6">Сколько времени в неделю вы планируете уделять разработке своего курса?</Typography>
                            <Typography>На этот вопрос можно дать любой ответ. Мы сможем помочь вам достичь поставленной цели, даже если у вас не очень много свободного времени.</Typography>
                            <FormControl component="fieldset" error={touched.planned_time && Boolean(errors.planned_time)} sx={{ marginTop: '32px', width: '100%' }}>
                                <Field as={RadioGroup} name="planned_time">
                                    {["0", "1", "2", "3"].map((value, index) => (
                                        <div className="radio-wrapper" key={index}>
                                            <FormControlLabel
                                                value={value}
                                                control={<Radio />}
                                                label={getLabelByValue(value)}
                                                onChange={() =>  handleStepChange({ planned_time: value })}
                                            />
                                        </div>
                                    ))}
                                </Field>
                                {touched.planned_time && errors.planned_time && <FormHelperText>{errors.planned_time}</FormHelperText>}
                            </FormControl>
                        </div>
                        <div className="course-create-footer">
                            <Box sx={{
                                position: 'fixed',
                                right: 0,
                                bottom: 0,
                                background: '#ffffff',
                                borderTop: '1px solid rgba(1, 18, 36, 0.08)',
                                padding: '12px 32px',
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                zIndex: 1000,
                                boxSizing: 'border-box',
                            }}>
                            <Button variant="outlined" onClick={() => setStep(  2)} >Назад</Button>
                            <Button type="submit" variant="contained" sx={{ marginLeft: 'auto' }}>
                                Продолжить
                            </Button>
                                </Box>
                        </div>
                </Form>
            )}
        </Formik>
    );
};

const getLabelByValue = (value: string) => {
    switch (value) {
        case "0":
            return "Сейчас я очень занят (0-2 часа)";
        case "1":
            return "Я буду уделять этому посильное время (2-4 часов)";
        case "2":
            return "У меня достаточно времени (более 5 часов)";
        case "3":
            return "Еще не решил(-а), будет ли у меня время";
        default:
            return "";
    }
};

export default CourseCreateStepThree;
